import { trpc } from '@/shared/api';
export const useSupplierSettingsQuery = () => trpc.supplierSettings.get.useQuery();
